import { combineReducers } from "redux";
import departmentInfoReducer from "./departmentInfoSlice";
import applicationStatusReducer from "./applicationStatusSlice";

const reportsReducer = combineReducers({
    departmentInfo: departmentInfoReducer,
    applicationStatus: applicationStatusReducer,
})

export default reportsReducer